import { SocialIcon } from '../app/components/svg/socials/SocialsIcons';

export const sharableSocials = (url: string): { [type in SocialIcon]?: string } => ({
  [SocialIcon.facebook]: `https://www.facebook.com/share.php?u=${url.replace('https://', '').replace('http://', '')}`,
  [SocialIcon.x]: `https://x.com/share?url=${url}`,
  [SocialIcon.whatsapp]: `https://api.whatsapp.com/send?text=${url}`,
  [SocialIcon.linkedin]: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
})